module.exports = __webpack_public_path__ + "static/media/hobbies.923bb969.jpg";